var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "global-preferences preferences" },
    [
      _c(
        "VueFormField",
        { attrs: { title: "Normalize component names" } },
        [
          _c(
            "VueGroup",
            {
              staticClass: "extend",
              model: {
                value: _vm.$shared.componentNameStyle,
                callback: function($$v) {
                  _vm.$set(_vm.$shared, "componentNameStyle", $$v)
                },
                expression: "$shared.componentNameStyle"
              }
            },
            [
              _c("VueGroupButton", {
                attrs: { value: "original", label: "Original name" }
              }),
              _c("VueGroupButton", {
                attrs: { value: "class", label: "Pascal case" }
              }),
              _c("VueGroupButton", {
                attrs: { value: "kebab", label: "Kebab case" }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "VueFormField",
        { attrs: { title: "Theme" } },
        [
          _c(
            "VueGroup",
            {
              staticClass: "extend",
              model: {
                value: _vm.$shared.theme,
                callback: function($$v) {
                  _vm.$set(_vm.$shared, "theme", $$v)
                },
                expression: "$shared.theme"
              }
            },
            [
              _c("VueGroupButton", { attrs: { value: "auto", label: "Auto" } }),
              _c("VueGroupButton", {
                attrs: { value: "light", label: "Light" }
              }),
              _c("VueGroupButton", { attrs: { value: "dark", label: "Dark" } }),
              _c("VueGroupButton", {
                attrs: { value: "high-contrast", label: "High contrast" }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "VueFormField",
        { attrs: { title: "Display density" } },
        [
          _c(
            "VueGroup",
            {
              staticClass: "extend",
              model: {
                value: _vm.$shared.displayDensity,
                callback: function($$v) {
                  _vm.$set(_vm.$shared, "displayDensity", $$v)
                },
                expression: "$shared.displayDensity"
              }
            },
            [
              _c("VueGroupButton", { attrs: { value: "auto", label: "Auto" } }),
              _c("VueGroupButton", { attrs: { value: "low", label: "Low" } }),
              _c("VueGroupButton", { attrs: { value: "high", label: "High" } })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "VueFormField",
        {
          attrs: { title: "Editable props" },
          scopedSlots: _vm._u([
            {
              key: "subtitle",
              fn: function() {
                return [
                  _c("VueIcon", {
                    staticClass: "medium",
                    attrs: { icon: "warning" }
                  }),
                  _vm._v("\n      May print warnings in the console\n    ")
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "VueSwitch",
            {
              model: {
                value: _vm.$shared.editableProps,
                callback: function($$v) {
                  _vm.$set(_vm.$shared, "editableProps", $$v)
                },
                expression: "$shared.editableProps"
              }
            },
            [_vm._v("\n      Enable\n    ")]
          )
        ],
        1
      ),
      _c(
        "VueFormField",
        { attrs: { title: "Time Format" } },
        [
          _c(
            "VueSwitch",
            {
              attrs: { value: _vm.$shared.timeFormat === "ms" },
              on: {
                update: function(value) {
                  return (_vm.$shared.timeFormat = value ? "ms" : "default")
                }
              }
            },
            [_vm._v("\n      Display milliseconds\n    ")]
          )
        ],
        1
      ),
      _c(
        "VueFormField",
        { attrs: { title: "Detected Vue message" } },
        [
          _c(
            "VueSwitch",
            {
              model: {
                value: _vm.$shared.logDetected,
                callback: function($$v) {
                  _vm.$set(_vm.$shared, "logDetected", $$v)
                },
                expression: "$shared.logDetected"
              }
            },
            [_vm._v("\n      Display in browser console\n    ")]
          )
        ],
        1
      ),
      _c(
        "VueFormField",
        {
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function() {
                return [
                  _vm._v("\n      New Vuex backend\n      "),
                  _c("NewTag", { attrs: { version: 2 } })
                ]
              },
              proxy: true
            },
            {
              key: "subtitle",
              fn: function() {
                return [
                  _vm._v("\n      Faster and less memory-intensive\n    ")
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "VueSwitch",
            {
              model: {
                value: _vm.$shared.vuexNewBackend,
                callback: function($$v) {
                  _vm.$set(_vm.$shared, "vuexNewBackend", $$v)
                },
                expression: "$shared.vuexNewBackend"
              }
            },
            [_vm._v("\n      Enable\n    ")]
          )
        ],
        1
      ),
      _c(
        "VueFormField",
        {
          attrs: { title: "Autoload Vuex state" },
          scopedSlots: _vm._u([
            {
              key: "subtitle",
              fn: function() {
                return [
                  _c("VueIcon", {
                    staticClass: "medium",
                    attrs: { icon: "warning" }
                  }),
                  _vm._v(
                    "\n      May impact performance or cause crashes\n    "
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "VueSwitch",
            {
              model: {
                value: _vm.$shared.vuexAutoload,
                callback: function($$v) {
                  _vm.$set(_vm.$shared, "vuexAutoload", $$v)
                },
                expression: "$shared.vuexAutoload"
              }
            },
            [_vm._v("\n      Enable\n    ")]
          )
        ],
        1
      ),
      _c(
        "VueFormField",
        {
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function() {
                return [
                  _vm._v("\n      Group getters by module\n      "),
                  _c("NewTag", { attrs: { version: 2 } })
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "VueSwitch",
            {
              model: {
                value: _vm.$shared.vuexGroupGettersByModule,
                callback: function($$v) {
                  _vm.$set(_vm.$shared, "vuexGroupGettersByModule", $$v)
                },
                expression: "$shared.vuexGroupGettersByModule"
              }
            },
            [_vm._v("\n      Enable\n    ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }